'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomFieldsClient = undefined;

var _CustomFieldsClient = require('./CustomFieldsClient');

var _CustomFieldsClient2 = _interopRequireDefault(_CustomFieldsClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.CustomFieldsClient = _CustomFieldsClient2.default; /**
                                                            * This module exports the interface of the CustomFields package
                                                            *
                                                            * @module CustomFields
                                                            */


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/CustomFields/index.js
// module id = 320
// module chunks = 0